import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
const testimonials = [{
  initials: 'VM',
  name: 'Valeria M.',
  location: 'Buenos Aires',
  plan: 'MegaPack Completo',
  quote: 'Tres días y ya no me reconocía en el espejo. La cara marcada, el abdomen blando, el jean sin problema.'
}, {
  initials: 'ML',
  name: 'Mariana L.',
  location: 'Córdoba',
  plan: 'MegaPack + Jean Flojo',
  quote: 'El Tomo 5 del botiquín lo tengo abierto en el celular todo el tiempo. Por fin sé qué infusión tomar.'
}, {
  initials: 'SR',
  name: 'Sofía R.',
  location: 'Rosario',
  plan: 'MegaPack Completo',
  quote: 'En 3 días identifiqué que era el mate en ayunas con azúcar. Lo cambié y el resultado fue inmediato.'
}, {
  initials: 'PG',
  name: 'Patricia G.',
  location: 'Mendoza',
  plan: 'MegaPack + Jean Flojo',
  quote: 'En 30 días perdí la hinchazón que cargué 4 años. El jean del cajón ahora me queda flojo.'
}, {
  initials: 'LT',
  name: 'Luciana T.',
  location: 'La Plata',
  plan: 'MegaPack Completo',
  quote: 'Por fin puedo ir a un asado sin llegar a casa sintiéndome horrible.'
}];
export function Testimonials() {
  return <section className="py-20 px-4 bg-black border-t border-white/5" data-id="element-255">
      <div className="max-w-6xl mx-auto" data-id="element-256">
        <div className="mb-12" data-id="element-257">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-white flex items-center justify-center gap-3" data-id="element-258">
            <span className="text-brand-pink" data-id="element-259">❤️</span> MÁS PERSONAS QUE YA LO
            TIENEN
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-260">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-white/5 backdrop-blur-sm p-8 rounded-2xl border border-white/10 flex flex-col items-center h-full" data-id="element-261">
              <div className="flex gap-1 mb-4 text-yellow-400" data-id="element-262">
                {[...Array(5)].map((_, j) => <Star key={j} size={18} fill="currentColor" data-id="element-263" />)}
              </div>

              <p className="text-gray-300 italic mb-6 text-base leading-relaxed flex-grow" data-id="element-264">
                "{t.quote}"
              </p>

              <div className="flex flex-col items-center gap-2 pt-4 border-t border-white/10 w-full mt-auto" data-id="element-265">
                <div className="w-12 h-12 rounded-full bg-brand-green text-white flex items-center justify-center font-bold text-lg shadow-inner" data-id="element-266">
                  {t.initials}
                </div>
                <div data-id="element-267">
                  <p className="font-bold text-white" data-id="element-268">{t.name}</p>
                  <p className="text-xs text-gray-400 flex items-center gap-1 justify-center" data-id="element-269">
                    📍 {t.location} <span className="opacity-50" data-id="element-270">•</span>{' '}
                    <span className="font-medium text-brand-green" data-id="element-271">
                      {t.plan}
                    </span>
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}